import { Centre } from "../styled/Center.styled";

function BlogSocials(props) {
  return (
    <Centre>
      {/*  Go to www.addthis.com/dashboard to customize your tools */}
      <div className="addthis_inline_share_toolbox"></div>
    </Centre>
  );
}

export default BlogSocials;
